import { getTimeNow } from '@utils/getTimeNow'

export const isLiveProgram = (start: number, stop: number): boolean =>
  start <= getTimeNow() && stop >= getTimeNow()
